import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './events.css';
//Redux
import { setOldState, editEvents } from "../../../redux/actions";
import { connect } from "react-redux";
import Redirect from "../../../routes/Redirect";
import { Table, Button } from "reactstrap";


class Events extends React.Component {


    constructor(props) {
        super(props)


        this.state = {
            loading: false,
            redirect: false,
            eventsType: [],
            table: [],
            alert: { msg: '', type: '' },
            pathRedirect: '/admin/add-event',
            filter: this.props.oldState ? this.props.oldState.filter : { name: '', eventType: null }
        }
    }

    columns = ['Tipo', 'Nome', 'Código', 'Hardware', 'Peso', 'Ativo?']

    componentDidMount = () => {
        this.getEventsType()
        // console.log('old', this.props.oldState)
        
        if (this.props.oldState) {
            this.getEvents()

            this.props.setOldState(undefined)
            if (this.props.oldState.edit) {
                store.addNotification({ ...this.props.bodyNotify, title: `Evento: ${this.props.oldState.name} Salvo!`, type: 'success' });
            }
        } else {
            this.props.editEvents(undefined, undefined)

        }
    }

    getEventsType = () => {
        axios
            .get(
                `${url}/v1/telemetria/backoffice/events/listTypes/${this.props.token
                }`
            )
            .then(d => {
                let options = [];
                for (let i = 0; i < d.data.length; i++) {
                    options.push({
                        value: d.data[i],
                        label: d.data[i]
                    });
                }
                this.setState({ eventsType: options });
            })
            .catch(e => {
                console.log(e.response)

            });
    }

    getEvents = () => {
        this.setState({ loading: true, table: [], alert: {} })
        axios
            .post(`${url}/v1/telemetria/backoffice/events/list/${this.props.token}`, this.state.filter)
            .then(d => {
                console.log(d)
                if (d.data.length) this.setState({ loading: false, table: d.data });
                else this.setState({ loading: false, table: [], alert: { msg: 'Nenhum evento encontrado!', type: 'warning' } })


            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })

            });
    }

    handleEventsType = i => {
        console.log(i)
        var filter = this.state.filter
        if (!i) {
            filter.eventType = null
            this.setState({ filter })
            return;
        }
        filter.eventType = i.value;
        this.setState({ filter })
    };


    backPage = (name, edit) => {
        setTimeout(() => {
            this.props.setOldState({ ...this.props.oldStateFilter, name, edit })
            this.props.editEvents(undefined, undefined)
            this.setState({ redirect: true })
        }, 500);
    }

    editEvent = (d) => {
        // console.log(d);
        this.props.editEvents(d, { filter: this.state.filter, table: this.state.table })
        this.setState({ redirect: true, pathRedirect: '/admin/edit-event' })
    }



    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="event-name" className='toolbar-label'>Nome</label>
                    <input
                        id='event-name'
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, name: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Nome'
                        value={this.state.filter.name} />
                </div>
                <div>
                    <label htmlFor="tipo" className='toolbar-label'>Tipo</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='tipo'
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Tipo"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        closeMenuOnSelect={true}
                        isDisabled={this.state.loading}
                        isClearable
                        options={this.state.eventsType}
                        onChange={this.handleEventsType}
                        defaultInputValue={this.state.filter.eventType || ''}
                    />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getEvents()}
                    disabled={this.state.loading}
                />


            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}
                <Redirect to={this.state.pathRedirect} redirect={this.state.redirect} />

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div style={{marginRight: '10px'}}>
                        <div style={{marginTop: '60px', width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                            <Button
                                // disabled={!bodyFilter.startPeriod || !bodyFilter.endPeriod || this.state.loading}
                                disabled={this.props.loading}
                                color="primary"
                                className="btn-filter btn-header-table-events telemetry-button"
                                onClick={() => this.setState({ redirect: true, pathRedirect: '/admin/add-event' })}
                                // style={{}}
                            >
                                Novo Evento
                            </Button>


                        </div>
                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{  }}>{d}</th>
                                        )
                                    })}
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.table.map((d, i) => {

                                    return (
                                        <tr key={i} className='tr-table-pendencie tr-table-events  tr-table-change-color' onClick={() => this.editEvent(d)}>
                                            <td>{d.eventType}</td>
                                            <td>{d.name}</td>
                                            <td>{d.code}</td>
                                            <td>{d.hardware}</td>
                                            <td>{d.weight}</td>
                                            <td>{d.active ? 'Sim' : 'Não'}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        oldState: state.toSetOldState
    };
};

const mapDispatchToProps = dispatch => {
    return {
        editEvents: (data, oldState) => dispatch(editEvents(data, oldState)),
        setOldState: (data) => dispatch(setOldState(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);
